











































































































































































































































































































import { defineComponent, reactive, toRefs, computed, watch, onMounted, onBeforeUnmount, ref } from '@vue/composition-api';
import jsZip from "jszip";
import * as Common from "../../commons/common"
import moment from 'moment';
import http from "../../plugins/http";
import AlertArea from "../../components/AlertArea.vue";
import AnswerImageArea from "../../components/AnswerImageArea.vue";
import MovieContentArea from "../../components/MovieContentArea.vue";
import PreviewImageArea from "../../components/PreviewImageArea.vue";
import PreviewHeaderLeftArea from "../../components/PreviewHeaderLeftArea.vue";
import TextDirectionToggle from "../../components/TextDirectionToggle.vue";
import { BaseSheet, BaseSheetField, PageItem, DirectionEnum, AnswerText, ParamBaseSheetField, CurrentModeEnum, AnswerImage, QuestionImageDiscription, AnswerImageDiscription, RejectionStudentSheetLog } from "../../modules/student/ResultImagePreview"
import { MovieContent } from "../../modules/student/DigitalReport"
import { SplitterComponent, PanesDirective, PaneDirective, ResizingEventArgs } from "@syncfusion/ej2-vue-layouts"
import heic2any from "heic2any";

const PreviewImageTypeEnum = Common.PreviewImageTypeEnum;

export interface Data {
  initiarizedData: boolean
  student_sheet_id: string
  status: number
  times: number
  base_sheet: BaseSheet
  nendo: string
  subject_name: string
  report_no: number
  base64QuestionImages: string[]
  base64CorrectImages: string[]
  base64AnswerImages: string[]
  movieContents: MovieContent[]
  DirectionEnum: Readonly<{Horizon: number; Vertical: number;}>
  direction: number
  mainAreaWidth: number
  mainAreaHeight: number
  horizonTopHeightPer: number
  horizonBottomHeightPer: number
  verticalLeftWidthPer: number
  verticalRightWidthPer: number
  separatorSize: number
  selectedAnswerPageIdx: number
  selectedQuestionPageIdx: number
  selectedCorrectPageIdx: number
  before_student_sheet_id: number
  keyCode: string
  pcHelpFields: any[]
  tabletHelpFields: any[]
  errors: string[]
  scored_user_name: string
  CurrentModeEnum: Readonly<{Answer: number; SelfScoring: number; Preview: number;}>
  currentMode: number
  answerImageDiscriptions: AnswerImageDiscription[]
  questionImageDiscriptions: QuestionImageDiscription[]
  previewImateTypes: number[]
  previewImageType: number
}

// @ts-ignore
export default defineComponent({
  components: {
    "alert-area": AlertArea,
    "answer-image-area": AnswerImageArea,
    "movie-content-area": MovieContentArea,
    "preview-image-area": PreviewImageArea,
    "preview-header-left-area": PreviewHeaderLeftArea,
    "ejs-splitter" : SplitterComponent,
    "e-panes": PanesDirective,
    "e-pane": PaneDirective,
    "text-direction-toggle": TextDirectionToggle,
  },
  setup(props, context){

    const horizonAnswerImageAreaRef = ref<InstanceType<typeof AnswerImageArea>>();
    const verticalAnswerImageAreaRef = ref<InstanceType<typeof AnswerImageArea>>();
    const horizonQuestionImageAreaRef = ref<InstanceType<typeof PreviewImageArea>>();
    const verticalQuestionImageAreaRef = ref<InstanceType<typeof PreviewImageArea>>();
    const horizonCorrectImageAreaRef = ref<InstanceType<typeof PreviewImageArea>>();
    const verticalCorrectImageAreaRef = ref<InstanceType<typeof PreviewImageArea>>();

    const AnswerTypeEnum = Common.AnswerTypeEnum;
    const StmapTypeEnum = Common.StmapTypeEnum;

    /******************************
     * data
     ******************************/
    const state = reactive<Data>({
      initiarizedData: false,
      student_sheet_id: null,
      status: null,
      times: null,
      base_sheet: null,
      nendo: null,
      subject_name: null,
      report_no: null,
      base64QuestionImages: [],
      base64CorrectImages: [],
      base64AnswerImages: [],
      movieContents: [],
      DirectionEnum: DirectionEnum,
      direction: DirectionEnum.Vertical,
      mainAreaWidth: 0,
      mainAreaHeight: 0,
      horizonTopHeightPer: 0.5,
      horizonBottomHeightPer: 0.5,
      verticalLeftWidthPer: 0.5,
      verticalRightWidthPer: 0.5,
      separatorSize: 10,
      selectedAnswerPageIdx: 0,
      selectedQuestionPageIdx: 0,
      selectedCorrectPageIdx: 0,
      before_student_sheet_id: null,
      keyCode: null,
      pcHelpFields: [
        { key: "Ctrlキー + マウスホイール", img: require("@/assets/images/keyboard_Ctrl.png"), description: "拡大縮小" },
        { key: "Shiftキー + マウスホイール", img: require("@/assets/images/keyboard_Shift.png"), description: "左右にスクロール" },
        ],
      tabletHelpFields: [
        { key: "問題用紙または解答用紙上でピンチイン・ピンチアウト", description: "用紙の拡大縮小" },
      ],
      errors: [],
      scored_user_name: null,
      CurrentModeEnum: CurrentModeEnum,
      currentMode: null,
      answerImageDiscriptions: [],
      questionImageDiscriptions: [],
      previewImateTypes: [],
      previewImageType: PreviewImageTypeEnum.None,
    });

    const DrawModeEnum = Common.DrawModeEnum;

    /************************************************************
     * 採点結果PDF表示
     ************************************************************/

    const downloadResultPdf = async () => {
      context.root.$store.dispatch("showOverlay");
      
      await http.get(`/api/student/student_sheet_list/download_result_pdf/${state.before_student_sheet_id}`, {responseType: 'arraybuffer'}).then(response => {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const a = document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.target = "_blank"
        a.click();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /************************************************************
     * メインエリアの高さを画面サイズに合わせてリサイズ
     * 初期表示・ウィンドウリサイズ時に発動
     ************************************************************/

    const adjustHeight = () => {
      const windowHeight = window.innerHeight;
      const windowWidth = window.innerWidth;
      const mainArea = document.getElementById("main-area");
      
      if(mainArea != null){
        state.mainAreaHeight = windowHeight - mainArea.offsetTop;
        state.mainAreaWidth = windowWidth;
        mainArea.style.width = state.mainAreaWidth + "px";
        mainArea.style.height = windowHeight - mainArea.offsetTop + "px";
      }
    };

    /************************************************************
     * 問題用紙・解答用紙を画面内に収まるようにリサイズ
     ************************************************************/

    const adjustSheet = () => {
      const questionArea = document.getElementById(`question-page-root-${state.direction}-${state.base_sheet.sheet_type}`);
      const correctArea = document.getElementById(`correct-page-root-${state.direction}-${state.base_sheet.sheet_type}`);
      const answerArea = document.getElementById(`answer-page-root-${state.direction}-${state.base_sheet.sheet_type}`);
      const mainArea = document.getElementById("main-area");

      if(questionArea && mainArea){
        const areaW = questionArea.clientWidth - 16;
        const areaH = mainArea.clientHeight - 80;
        
        const scaleW = areaW / state.base_sheet.questionImageWidth;
        const scaleH = areaH / state.base_sheet.questionImageHeight;
        const scale = scaleW > scaleH ? scaleH * 100 : scaleW * 100;
        verticalQuestionImageAreaRef.value.inputScale = scale;
        horizonQuestionImageAreaRef.value.inputScale = scale;
      }

      if(correctArea && mainArea){
          const areaW = correctArea.clientWidth - 16;
          const areaH = mainArea.clientHeight - 80;
          
          const scaleW = areaW / state.base_sheet.width;
          const scaleH = areaH / state.base_sheet.height;
          const scale = scaleW > scaleH ? scaleH * 100 : scaleW * 100;
          verticalCorrectImageAreaRef.value.inputScale = scale;
          horizonCorrectImageAreaRef.value.inputScale = scale;
        }

      if(answerArea && mainArea){
        const areaW = answerArea.clientWidth - 16;
        const areaH = mainArea.clientHeight - 80;
        
        const scaleW = areaW / state.base_sheet.width;
        const scaleH = areaH / state.base_sheet.height;
        const scale = scaleW > scaleH ? scaleH * 100 : scaleW * 100;

        verticalAnswerImageAreaRef.value.inputScale = scale;
        horizonAnswerImageAreaRef.value.inputScale = scale;
      }
    }

    /************************************************************
     * 横向きモードのスプリッターリサイズ
     ************************************************************/

    const horizonHeightPaneResizing = (e: ResizingEventArgs) => {
      state.horizonTopHeightPer = e.paneSize[0] / state.mainAreaHeight;
      state.horizonBottomHeightPer = e.paneSize[1] / state.mainAreaHeight;
    }

    /************************************************************
     * 縦向きモードのスプリッターリサイズ
     ************************************************************/

    const verticalWidthPaneResizing = (e: ResizingEventArgs) => {
      state.verticalLeftWidthPer = e.paneSize[0] / state.mainAreaWidth;
      state.verticalRightWidthPer = e.paneSize[1] / state.mainAreaWidth;
    }

    /************************************************************
     * 横向きモードの上部エリアのheight
     ************************************************************/

    const horizonModeTopHeight = computed((): any => {
      return state.mainAreaHeight * state.horizonTopHeightPer;
    });

    /************************************************************
     * 横向きモードの下部エリアのheight
     ************************************************************/

    const horizonModeBottomHeight = computed((): any => {
      return state.mainAreaHeight * state.horizonBottomHeightPer;
    });

    /************************************************************
     * 画面レイアウト縦横モード切り替え
     ************************************************************/

    const changeDirection = (direction: number) => {
      if(state.direction != direction){
        state.direction = direction;
      }
    }

    /******************************
     * 解答用紙ページ切り替え時のemit
     ******************************/

    const answerSheetPageChanged = (idx: number) => {
      state.selectedAnswerPageIdx = idx;
    }

    /******************************
     * 問題用紙ページ切り替え時のemit
     ******************************/

    const questionSheetPageChanged = (idx: number) => {
      state.selectedQuestionPageIdx = idx;
    }

    /******************************
     * 模範解答ページ切り替え時のemit
     ******************************/

     const correctImagePageChanged = (idx: number) => {
      state.selectedCorrectPageIdx = idx;
    }

    /******************************
     * 問題用紙・模範解答表示切り替え
     ******************************/

     const changeImageType = (imageType: number) => {
      state.previewImageType = imageType;
    }

    /************************************************************
     * ピンチインアウトによる画面の拡大縮小禁止処理
     ************************************************************/

    const rootTouchmove = (e: TouchEvent) => {
      if(e.touches.length > 1){
        e.preventDefault();
      }
    }

    /************************************************************
     * キー押下
     ************************************************************/

     const keyDown = (e:KeyboardEvent) => {
      state.keyCode = e.key;
    }

    /************************************************************
     * キー入力による採点
     ************************************************************/

     const keyUp = (e: KeyboardEvent) => {
      state.keyCode = "";
    }

    /************************************************************
     * mounted
     ************************************************************/

    onMounted(async () => {

      if(context.root.$store.state.isKaitouViewReloaded){
        context.root.$store.commit("setIsKaitouViewReloaded", false);
      }else{
        context.root.$store.commit("setIsKaitouViewReloaded", true);
        window.location.reload();
        return;
      }
      
      if(!Common.studentSiteLoginCheck(context)){
        return;
      }

      context.root.$store.commit("setIsHeaderDisp", false);
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");

      let isLoadFailed = false;
      await http.get(`/api/student/result_image_preview?student_sheet_id=${context.root.$route.params.student_sheet_id}&student_code=${context.root.$store.state.student_code}`).then(response => {
        state.base_sheet = new BaseSheet(response.data.base_sheet);
        state.subject_name = response.data.subject_name ? response.data.subject_name : "削除された科目";
        state.report_no = response.data.student_sheet.report_no;
        state.nendo = response.data.student_sheet.nendo;
        state.base64QuestionImages = response.data.base64_question_images;
        state.base64CorrectImages = response.data.base64_correct_images;
        state.base64AnswerImages = response.data.base64_answer_images;
        state.movieContents = response.data.movie_contents;
        state.before_student_sheet_id = response.data.before_student_sheet_id;
        state.scored_user_name = response.data.scored_user_name;
        state.answerImageDiscriptions = response.data.answer_image_discriptions;
        state.questionImageDiscriptions = response.data.question_image_discriptions;

        // 動画・模範解答・問題用紙の表示設定
        const previewImateTypes: number[] = [];
        if(state.movieContents.length > 0){
          previewImateTypes.push(PreviewImageTypeEnum.Movie);
        }
        if(state.base64CorrectImages.length > 0){
          previewImateTypes.push(PreviewImageTypeEnum.Correct);
        }
        if(state.base64QuestionImages.length > 0){
          previewImateTypes.push(PreviewImageTypeEnum.Question);
        }
        state.previewImateTypes = previewImateTypes;
        state.previewImageType = previewImateTypes.length > 0 ? previewImateTypes[0] : PreviewImageTypeEnum.None;
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        isLoadFailed = true;
        if(error.response.status == 422){
          alert(`レポート情報の取得処理に失敗しました。レポート一覧に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`レポート情報の取得処理に失敗しました。レポート一覧に戻ります。`);
        }
        window.history.back();
      });

      if(isLoadFailed){
        context.root.$store.dispatch("hideOverlay");
        return;
      }

      state.initiarizedData = true;
      context.root.$nextTick(() => {
        adjustHeight();
        adjustSheet();
      });
      window.addEventListener("resize", adjustHeight);
      window.addEventListener("orientationchange", adjustHeight);
      window.addEventListener("keyup", keyUp);
      window.addEventListener("keydown", keyDown);
      document.body.style.overflow = "hidden";

      context.root.$store.dispatch("hideOverlay");
    });

    /******************************
     * Before Unmount
     ******************************/

    onBeforeUnmount(async () => {
      window.removeEventListener("resize", adjustHeight);
      window.removeEventListener("orientationchange", adjustHeight);
      window.removeEventListener("keyup", keyUp);
      window.removeEventListener("keydown", keyDown);
      context.root.$store.commit("setIsHeaderDisp", true);
      document.body.style.overflow = "";
    });

    return {
      ...toRefs(state),
      DrawModeEnum,
      StmapTypeEnum,
      PreviewImageTypeEnum,
      horizonAnswerImageAreaRef,
      verticalAnswerImageAreaRef,
      horizonCorrectImageAreaRef,
      verticalCorrectImageAreaRef,
      horizonQuestionImageAreaRef,
      verticalQuestionImageAreaRef,
      AnswerTypeEnum,
      horizonHeightPaneResizing,
      verticalWidthPaneResizing,
      horizonModeTopHeight,
      horizonModeBottomHeight,
      changeDirection,
      answerSheetPageChanged,
      questionSheetPageChanged,
      correctImagePageChanged,
      changeImageType,
      downloadResultPdf,
      keyDown,
      keyUp,
      rootTouchmove,
     };
  }
})
